/**
 * RallyClip v1 input kinds (docs/design/rallyclip-v1/api-schemas.md
 * "Get the job result"; issue #1866, M-13a).
 *
 * The merged API omits ``input_kind`` for every v0 job so that v0
 * responses stay byte-for-byte what they were. Every Segment Web read
 * of the field therefore goes through :func:`inputKindOf`, which maps
 * an absent (or null) key to ``video_v0`` — never compare the raw field
 * against a literal.
 */

export const INPUT_KIND_V0 = "video_v0";
export const INPUT_KIND_V1 = "device_detections_v1";

export type JobInputKind = typeof INPUT_KIND_V0 | typeof INPUT_KIND_V1;

/** The minimal shape both list rows and detail responses satisfy. */
export interface KindedJob {
  input_kind?: string | null;
}

/** The job's input kind, reading an absent key as ``video_v0``. */
export function inputKindOf(job: KindedJob): JobInputKind {
  return job.input_kind === INPUT_KIND_V1 ? INPUT_KIND_V1 : INPUT_KIND_V0;
}

/** True iff the job was submitted as a phone detection bundle. */
export function isV1Job(job: KindedJob): boolean {
  return inputKindOf(job) === INPUT_KIND_V1;
}
